import { Button, Form, message } from "antd";
import React from "react";
import { useTranslation } from 'react-i18next';
import { updateModulesOrder } from "../apis";
import ActivityIcon from "../Assets/icons/rounded_activity_icons.png";
import ModulesIcon from "../Assets/icons/rounded_module_icons.png";
import PasswordIcon from "../Assets/icons/rounded_password_icon.png";
import ProfileIcon from "../Assets/icons/rounded_profile_icon.png";
import { MODULE_DEFINITIONS } from "../data/MODULE_DEFINITIONS";
import { changePassword, updateMyProfile } from "../apis";
import ActivityPage from "./ActivityLogsPage";
import ModulesPage from "./ModulesPage";
import PasswordPage from "./PasswordPage";
import ProfilePage from "./ProfilePage";

function PageLayout({ activeItem, user }) {
  const { t } = useTranslation();
  var [userInfo, setUserInfo] = React.useState(user);
  const [modules, setModules] = React.useState([]);

  var [file, setFile] = React.useState(null);
  var [loading, setLoading] = React.useState(false);
  const [apiStatus, setApiStatus] = React.useState(null);
  const [pwd, setPwd] = React.useState("");
  const [form] = Form.useForm();

  var ProfileUpdate = async () => {
    setLoading(true);
    var formData = new FormData();
    formData.append("first_name", userInfo.first_name);
    formData.append("last_name", userInfo.last_name);
    formData.append("email", userInfo.email);
    formData.append("gender", userInfo.gender);
    formData.append("number", userInfo.number);
    formData.append("address", userInfo.address);
    formData.append("company", userInfo.company);

    if (file) {
      formData.append("profile_image", file);
    }
    var response = await updateMyProfile(formData);
    if (response.status === 200) {
      // TODO DISPLAY SUCCESS MESSAGE
      window.location.reload();
    } else {
      // TODO DISPLAY ERROR MESSAGE
    }
    setLoading(false);
  };

  const handleUpdatePassword = async () => {
    setLoading(true);
    setApiStatus(null);
    try {
      const passwordData = {
        current_password: form.getFieldValue("currentPassword"),
        new_password: form.getFieldValue("newPassword"),
        confirm_password: form.getFieldValue("confirmPassword"),
      };

      const res = await changePassword(passwordData);
      const successMsg = res?.message || t('settings.password.successMessage');
      setApiStatus({ type: "success", message: successMsg });
      message.success(successMsg);
      form.resetFields();
      setPwd("");
    } catch (error) {
      console.error("Error changing password:", error);
      const backendMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        t('settings.password.errorMessage');
      setApiStatus({ type: "error", message: backendMsg });
      message.error(backendMsg);

      // If backend says current password is incorrect, mark the field
      const statusCode = error?.response?.status;
      if (statusCode === 401 || /current password/i.test(backendMsg)) {
        form.setFields([
          {
            name: "currentPassword",
            errors: [backendMsg],
          },
        ]);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSaveModule = async () => {
    try {
      setLoading(true);

      // Get module names in current order
      const moduleNames = modules.map((module) => {
        // Find the original module key from MODULE_DEFINITIONS by matching the computed id
        const moduleEntry = Object.entries(MODULE_DEFINITIONS).find(
          ([key, def]) => {
            const computedId = (def.key || key)
              .toString()
              .replace(/^\//, "")
              .toLowerCase()
              .replace(/\s+/g, "_");
            return computedId === module.id;
          }
        );
        // Return the original key from MODULE_DEFINITIONS (not the label)
        return moduleEntry ? moduleEntry[0] : module.id;
      });

      await updateModulesOrder(moduleNames);
      message.success(t('settings.modules.orderSuccess'));
      // Refresh the page to reflect updated modules configuration
      window.location.reload();
    } catch (error) {
      console.error("Error saving modules order:", error);
      message.error(t('settings.modules.orderError'));
    } finally {
      setLoading(false);
    }
  };

  var onUpdate = async () => {
    if (activeItem === "profile") {
      await ProfileUpdate();
    }
    if (activeItem === "password") {
      await handleUpdatePassword();
    }
    if (activeItem === "modules") {
      await handleSaveModule();
    }
  };

  var onCancel = () => {
    setUserInfo(user);
  };

  var onImageChange = (file) => {
    setFile(file);
  };

  var renderTitle = () => {
    switch (activeItem) {
      case "profile":
        return t('settings.profile.title');
      case "password":
        return t('settings.password.title');
      case "modules":
        return t('settings.modules.title');
      case "activity":
        return t('settings.activity.title');
      default:
        return t('settings.profile.title');
    }
  };

  var renderIcon = () => {
    switch (activeItem) {
      case "profile":
        return <img src={ProfileIcon} alt="Profile" />;
      case "password":
        return <img src={PasswordIcon} alt="Password" />;
      case "modules":
        return <img src={ModulesIcon} alt="Modules" />;
      case "activity":
        return <img src={ActivityIcon} alt="Activity" />;
      default:
        return <img src={ProfileIcon} alt="Profile" />;
    }
  };

  var renderForm = () => {
    switch (activeItem) {
      case "profile":
        return (
          <ProfilePage
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            onImageChange={onImageChange}
          />
        );
      case "password":
        return (
          <PasswordPage
            pwd={pwd}
            setPwd={setPwd}
            form={form}
            apiStatus={apiStatus}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          />
        );
      case "modules":
        return (
          <ModulesPage
            modules={modules}
            setModules={setModules}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          />
        );
      case "activity":
        return <ActivityPage userInfo={userInfo} setUserInfo={setUserInfo} />;
      default:
        return <ProfilePage f userInfo={userInfo} setUserInfo={setUserInfo} />;
    }
  };

  return (
    <div className="settings-item-layout from-layout">
      <div className="settings-layout-title">
        {" "}
        {renderIcon()} {renderTitle()}{" "}
      </div>
      <div> {renderForm()} </div>
      <div className="settings-buttons-form">
        <Button onClick={onCancel}>{t('settings.buttons.cancel')}</Button>
        <Button
          onClick={onUpdate}
          loading={loading}
          type="primary"
          style={{
            background: "var(--secondary-color)",
            borderColor: "var(--secondary-color)",
            color: "var(--primary-color)",
          }}
        >
          {t('settings.buttons.update')}
        </Button>
      </div>
    </div>
  );
}

export default PageLayout;
